import $ from 'jquery';
import SVGInjector from 'svg-injector';
import { triggerStateChangedRequest } from '~core';
import { getFormatNameAndOrientration } from '~loader/loader-utils';
import { editorConfig } from '~config';
import { getState } from '~src/state';
import { doesSelectedProjectRequireFuneral } from '~loader/loader-utils';
import { handleShadowColorChange } from '~src/sidebar/index';
import { deleteAnimationsByObjRefId } from '~video';
import { toggleMagicFrameEditMode } from '~core/magicFrame';
import { clearSelectionsStyles } from '~src/utils';

function setSvgColor(id, color) {
  const paths = $(id).find('path');

  for (let i = 0; i < paths.length; i++) {
    paths[i].setAttribute('style', `fill:${color}`);
  }

  const rects = $(id).find('rect');

  for (let i = 0; i < rects.length; i++) {
    rects[i].setAttribute('style', `fill:${color}`);
  }
}

function getFontSizeValue() {
  let fontSize;

  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    // the text object is being edited
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.fontSize
    ) {
      // everything was selected
      fontSize = activeObject.get('fontSize');
    } else if (selectionStart === selectionEnd) {
      // no text was selected
      fontSize = activeObject.get('fontSize');
    } else {
      // a portion of text was selected
      const selectionStyles = activeObject.getSelectionStyles();
      if (selectionStyles && selectionStyles.length > 0 && selectionStyles[0]) {
        fontSize = selectionStyles[0]['fontSize'];
      }

      // the child does not have a custom font size
      if (!fontSize) {
        fontSize = activeObject.get('fontSize');
      }
    }
  } else {
    // the text object is simply selected
    fontSize = activeObject.get('fontSize');
  }
  return fontSize;
}

function updateTextColorControl() {
  let hexColor;
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    // the text object is being edited
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      hexColor = activeObject.get('fill');
    } else if (selectionStart === selectionEnd) {
      // no text was selected
      hexColor = activeObject.get('fill');
    } else {
      // a portion of text was selected
      const selectionStyles = activeObject.getSelectionStyles();
      if (selectionStyles && selectionStyles.length > 0 && selectionStyles[0]) {
        hexColor = selectionStyles[0]['fill'] || activeObject.get('fill');
      } else {
        hexColor = activeObject.get('fill');
      }
    }
  } else {
    // the text object is simply selected
    hexColor = activeObject.get('fill');
  }
  // $('#editor-menu-text-color color-block').css('background-color', hexColor);
  $('#color-text').css('background-color', hexColor);
}

async function changeFontColor() {
  const hexColor = $(this).data('hex-color');
  const activeObject = getState('activeObject');

  if (getState('setShadowColorActive', false)) {
    return handleShadowColorChange(hexColor);
  }

  if (getState('setTextBorderColorActive', false)) {
    const { handleTextBorderColorChange } = await import(
      '~src/sidebar/handleTextBorderColorChange'
    );
    return handleTextBorderColorChange(hexColor);
  }

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'fill');
      activeObject.set('fill', hexColor);
    } else if (selectionStart === selectionEnd) {
      // no text was selected
      activeObject.set('fill', hexColor);
    } else {
      // a portion of text was selected
      activeObject.setSelectionStyles({
        fill: hexColor,
      });
    }
  } else {
    clearSelectionsStyles(activeObject, 'fill');
    activeObject.set('fill', hexColor);
  }
  window.canvas.renderAll();
  updateTextColorControl();
  triggerStateChangedRequest();
}

function addDefaultColors() {
  const html = editorConfig.defaultColors.reduce((acc, color) => {
    const colorHtml = `<div style="background-color:${color};" data-hex-color="${color}" class="color-box"></div>`;
    acc += colorHtml;

    return acc;
  }, '');

  $('#colors-default').html(html);

  $('[data-hex-color').click(changeFontColor);
}

function initColors() {
  addDefaultColors();
}

function updateFontSizeInput() {
  let fontSize = getFontSizeValue() / 10;
  $('#editor-font-size-input').val(fontSize.toFixed(0));
}

function updateTextAlignControl() {
  let textAlign;

  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    // the text object is being edited
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      textAlign = activeObject.get('textAlign');
    } else if (selectionStart === selectionEnd) {
      // no text was selected
      textAlign = activeObject.get('textAlign');
    } else {
      // a portion of text was selected
      const selectionStyles = activeObject.getSelectionStyles();
      if (selectionStyles && selectionStyles.length > 0 && selectionStyles[0]) {
        textAlign =
          selectionStyles[0]['textAlign'] || activeObject.get('textAlign');
      } else {
        textAlign = activeObject.get('textAlign');
      }
    }
  } else {
    // the text object is simply selected
    textAlign = activeObject.get('textAlign');
  }

  setSvgColor(
    '#editor-menu-text-align-left',
    editorConfig.styles.inactiveControlColor
  );
  setSvgColor(
    '#editor-menu-text-align-center',
    editorConfig.styles.inactiveControlColor
  );
  setSvgColor(
    '#editor-menu-text-align-right',
    editorConfig.styles.inactiveControlColor
  );
  setSvgColor(
    '#editor-menu-text-align-justify',
    editorConfig.styles.inactiveControlColor
  );

  setSvgColor(
    `#editor-menu-text-align-${textAlign}`,
    editorConfig.styles.activeControlColor
  );
}

function updateTextSpacingControls() {
  let charSpacing;
  let lineHeight;
  const activeObject = getState('activeObject');

  charSpacing = activeObject.get('charSpacing');
  lineHeight = activeObject.get('lineHeight');

  // Horizontal
  $('#editor-text-spacing-h-slider').val(charSpacing);
  $('#editor-text-spacing-h-value').val(charSpacing);

  // Vertical
  $('#editor-text-spacing-v-slider').val(lineHeight);
  $('#editor-text-spacing-v-value').val(lineHeight);
}

function updateTextOpacityControl() {
  const activeObject = getState('activeObject');
  const opacity = activeObject.get('opacity');

  // Vertical
  $('#editor-text-opacity-slider').val(opacity);
}

export const isGroupSelection = () => {
  const getActiveObject = window.canvas.getActiveObject();
  const isGroup =
    typeof getActiveObject._objects !== 'undefined' &&
    getActiveObject._objects instanceof Array &&
    getActiveObject._objects.length > 0;

  return isGroup;
};

function deleteObject() {
  const objects = window.canvas.getActiveObjects();

  objects.forEach((obj) => {
    // La foto interna della cornice magica non si elimina da sola: la cornice
    // resterebbe con un editingImg staccato dal canvas e la modifica
    // crasherebbe al toggle successivo.
    if (obj._magicFrame) {
      return;
    }
    if (obj.type === 'MagicFrame') {
      // destroy() rimuove dal canvas anche l'editingImg collegato
      obj.destroy();
    }
    window.canvas.remove(obj);
    deleteAnimationsByObjRefId(obj);
  });
  window.canvas.discardActiveObject().renderAll();

  triggerStateChangedRequest();
}

function deselectObjects() {
  const activeObjects = window.canvas.getActiveObjects();

  for (const activeObject of activeObjects) {
    if (activeObject.type === 'MagicFrame') {
      if (activeObject.isEditing) {
        toggleMagicFrameEditMode();
      }
    } else if (typeof activeObject._magicFrame !== 'undefined') {
      if (activeObject._magicFrame.isEditing) {
        toggleMagicFrameEditMode();
      }
    }
  }
  window.canvas.discardActiveObject().renderAll();
}

function fixTooltipIssueOnClick() {
  $('[data-toggle="tooltip"]').on('click', function () {
    $(this).tooltip('hide');
  });
}

function injectSvgIcons() {
  const mySVGsToInject = document.querySelectorAll('img.inject-me');

  const injectorOptions = {
    evalScripts: 'once',
    pngFallback: 'assets/png',
    each: function (svg) {
      // Callback after each SVG is injected
      const id = svg.getAttribute('id');
      setSvgColor(`#${id}`, editorConfig.styles.inactiveControlColor);
    },
  };

  SVGInjector(mySVGsToInject, injectorOptions);
}

function displayHeaderControls() {
  $('#editor-header-controls').show();
}

function setHeaderSummary() {
  const requiresFuneral = doesSelectedProjectRequireFuneral();
  const format = getState('selected.formato');
  const projectType = getState('selected.tipo');
  const template = getState('selected.template');

  if (requiresFuneral) {
    const servizio = getState('selected.servizio', {});
    if (servizio) {
      const nomeDefunto = `${servizio.nome} ${servizio.cognome}`;
      $('#editor-header-defunto').text(nomeDefunto);
    }
  }

  const { name: formatName } = getFormatNameAndOrientration(format);

  $('#editor-header-tipo').text(projectType.name);
  $('#editor-header-formato').text(formatName);
  if (template && template.name) {
    $('#editor-header-modello').text(template.name);
  }
  $('#editor-header-section').show();
}

const changeToLock = () => {
  $('#img-lock').attr({ style: 'content:url(/assets/svg/img-un-lock.svg)' });
};

const changeToUnLock = () => {
  $('#img-lock').attr({ style: 'content:url(/assets/svg/img-lock.svg)' });
};

const unlockObject = (object) => {
  object.set({
    lockMovementX: false,
    lockMovementY: false,
    lockScalingX: false,
    lockScalingY: false,
    lockRotation: false,
    borderColor: '#ccc',
  });

  if (object.type === 'textbox') {
    object.set({
      editable: true,
    });
  }
};

const lockObject = (object) => {
  object.set({
    lockMovementX: true,
    lockMovementY: true,
    lockScalingX: true,
    lockScalingY: true,
    lockRotation: true,
    borderColor: 'red',
  });
  if (object.type === 'textbox') {
    object.set({
      editable: false,
    });
  }
};

const toggleObjectLock = () => {
  const selection = window.canvas.getActiveObject();

  if (!selection) {
    throw new Error('No objects selected');
  }

  let objects;

  if (isGroupSelection()) {
    objects = selection._objects;
  } else {
    objects = [selection];
  }

  const objectsLocked = [];
  objects.forEach((object) => {
    const isLocked = object.lockMovementY && object.lockMovementX;
    objectsLocked.push(!isLocked);

    if (isLocked) {
      unlockObject(object);
      changeToLock();
    } else {
      lockObject(object);
      changeToUnLock();
    }
  });

  if (isGroupSelection()) {
    const atLeastOneIsLocked = objectsLocked.includes(true);

    if (atLeastOneIsLocked) {
      const selection = window.canvas.getActiveObject();
      selection.set({
        lockMovementX: true,
        lockMovementY: true,
        lockScalingX: true,
        lockScalingY: true,
        lockRotation: true,
        borderColor: 'red',
      });
    } else {
      const selection = window.canvas.getActiveObject();
      selection.set({
        lockMovementX: false,
        lockMovementY: false,
        lockScalingX: false,
        lockScalingY: false,
        lockRotation: false,
        borderColor: '#ccc',
      });
    }
  }

  window.canvas.renderAll();
  triggerStateChangedRequest();
};

export {
  deleteObject,
  displayHeaderControls,
  fixTooltipIssueOnClick,
  initColors,
  injectSvgIcons,
  setHeaderSummary,
  setSvgColor,
  updateTextAlignControl,
  updateTextColorControl,
  updateFontSizeInput,
  updateTextSpacingControls,
  updateTextOpacityControl,
  getFontSizeValue,
  toggleObjectLock,
  changeToUnLock,
  changeToLock,
  lockObject,
  unlockObject,
  deselectObjects,
};
